'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findColumnClusters = exports.findTopLevelClusters = exports.findClusters = undefined;

var _dendrogram = require('./structures/dendrogram');

var dendrogramLib = _interopRequireWildcard(_dendrogram);

var _screePlot = require('./structures/screePlot');

var screePlotLib = _interopRequireWildcard(_screePlot);

var _cluster = require('./structures/cluster');

var clusterLib = _interopRequireWildcard(_cluster);

var _clusterDistance = require('./clusterDistance');

var distanceLib = _interopRequireWildcard(_clusterDistance);

var _documentOrderAlgorithmConstants = require('./documentOrderAlgorithmConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var findClusters = exports.findClusters = function findClusters(initialClusters, distanceFn, autoClusterDistance) {
    if (initialClusters.length <= 1) {
        return {
            clusters: initialClusters,
            dendrogramData: {},
            elbowPointData: {},
            earlyExit: true
        };
    }

    // Create a Dendrogram & Scree plot
    var dendrogramData = dendrogramLib.createDendrogram(initialClusters, distanceFn, autoClusterDistance);

    // Split the dendrogram into its clusters
    var elbowPointData = screePlotLib.findElbowPoint(dendrogramData.screePlot);

    return {
        clusters: dendrogramLib.getClustersBelow(dendrogramData.rootCluster, elbowPointData.elbowPoint.height),
        dendrogramData: dendrogramData,
        elbowPointData: elbowPointData,
        earlyExit: false
    };
};

// Constants
/**
 * Functions to build an array of clusters.
 */

// Utils
var findTopLevelClusters = exports.findTopLevelClusters = function findTopLevelClusters(documentElements) {
    // First initial singleton clusters
    var initialClusters = documentElements.map(clusterLib.createLeafCluster);
    return findClusters(initialClusters, distanceLib.anyClusterSide, _documentOrderAlgorithmConstants.AUTO_CLUSTER_DISTANCE);
};

var findColumnClusters = exports.findColumnClusters = function findColumnClusters(cluster) {
    // First get the leaf clusters (singleton clustors) of this cluster
    var initialClusters = dendrogramLib.getLeafClusters(cluster);
    return findClusters(initialClusters, distanceLib.clusterTopAndBottom, _documentOrderAlgorithmConstants.AUTO_COLUMN_DISTANCE);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/clusterBuilder.js
// module id = 2257
// module chunks = 0